var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel granary-right-panel" },
    [
      _c(
        "bar-card",
        { attrs: { bg: "border-new" } },
        [
          _c("g-title", { attrs: { bg: "hjzzjz" } }, [_vm._v("帮镇扶村")]),
          _c("div", { staticClass: "content" }, [
            _c(
              "div",
              { staticClass: "top-content flex" },
              _vm._l(_vm.topList, function (item, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    class:
                      _vm.activeIndex === i
                        ? "top-item active-item"
                        : "top-item",
                    on: {
                      click: function ($event) {
                        return _vm.handleClick(i)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "top-num" }, [
                      _vm._v(_vm._s(item.num)),
                    ]),
                    _c("div", { staticClass: "name" }, [
                      _vm._v(" " + _vm._s(item.name) + " "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: item.unit,
                              expression: "item.unit",
                            },
                          ],
                        },
                        [_vm._v("（" + _vm._s(item.unit) + "） ")]
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
            _c("div", { staticClass: "fp-box" }, [
              _c("div", { staticClass: "area-title" }, [
                _vm._v(_vm._s(_vm.activeName) + "变化趋势"),
              ]),
              _c("div", { ref: "chart", staticClass: "charts" }),
            ]),
            _c("div", { staticClass: "fp-box zb-box" }, [
              _c("div", { staticClass: "area-title" }, [
                _vm._v("各区" + _vm._s(_vm.activeName) + "占比"),
              ]),
              _c("div", { staticClass: "chart-box" }, [
                _c(
                  "div",
                  { staticClass: "tab-box flex" },
                  _vm._l(_vm.typeList, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "tab-item",
                        class: { active: _vm.active === index },
                        on: {
                          click: function ($event) {
                            return _vm.changeType(index)
                          },
                        },
                      },
                      [_c("span", [_vm._v(_vm._s(item))])]
                    )
                  }),
                  0
                ),
                _c("div", { ref: "circleChart", staticClass: "charts" }),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }